export default [
    'Array.prototype.find',
    'Array.prototype.forEach',
    'Array.prototype.map',
    'document.head',
    'document.querySelector',
    'Element.prototype.classList',
    'Element.prototype.closest',
    'Element.prototype.matches',
    'Element.prototype.remove',
    'Element.prototype.replaceWith',
    'Event',
    'innerWidth',
    'innerHeight',
    'IntersectionObserver',
    'JSON',
    'Map',
    'matchMedia',
    'MediaQueryList.prototype.addEventListener',
    'MutationObserver',
    'Node.prototype.contains',
    'NodeList.prototype.forEach',
    'requestAnimationFrame',
    'requestIdleCallback',
    'ResizeObserver',
    'Set',
    'URLSearchParams',
    'XMLHttpRequest',
];
